import store from '../store'
import { createAppRouter } from './createRouter'

const router = createAppRouter(store)

export default router
